import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import classNames from 'classnames/bind';
import React, { memo } from 'react';
import { spreadDangerousChildren } from "../utils/spreadDangerousChildren";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var Link = /*#__PURE__*/memo(function (_ref) {
  var _cn;
  var children = _ref.children,
    extraAttributes = _ref.extraAttributes,
    href = _ref.href,
    icon = _ref.icon,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {
      return false;
    } : _ref$onClick,
    size = _ref.size,
    target = _ref.target,
    textUppercase = _ref.textUppercase,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'dark' : _ref$variant,
    buttonVariant = _ref.buttonVariant,
    buttonSize = _ref.buttonSize,
    isFullWidth = _ref.isFullWidth,
    isNoUnderline = _ref.isNoUnderline,
    rightIcon = _ref.rightIcon,
    _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'Link' : _ref$testName,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("a", _extends({
    className: cn('link', className, (_cn = {}, _defineProperty(_cn, "link--".concat(variant), Boolean(variant)), _defineProperty(_cn, "link--".concat(size), Boolean(size)), _defineProperty(_cn, 'link--uppercase', textUppercase), _defineProperty(_cn, 'link--no-underline', isNoUnderline), _defineProperty(_cn, 'link--with-icon', Boolean(icon) || Boolean(rightIcon)), _defineProperty(_cn, 'link--with-right-icon', Boolean(rightIcon)), _defineProperty(_cn, 'link--with-icon-s', (Boolean(rightIcon) || Boolean(icon)) && buttonSize === 's'), _defineProperty(_cn, 'link--with-icon-m', (Boolean(rightIcon) || Boolean(icon)) && buttonSize === 'm'), _defineProperty(_cn, 'link--with-icon-l', (Boolean(rightIcon) || Boolean(icon)) && buttonSize === 'l'), _defineProperty(_cn, "link--button-".concat(buttonVariant), variant === 'button' && Boolean(buttonVariant)), _defineProperty(_cn, "link--button-".concat(buttonSize), variant === 'button' && Boolean(buttonSize)), _defineProperty(_cn, 'link--button-full', isFullWidth && variant === 'button'), _cn)),
    "data-component": testName,
    "data-name": "Link",
    href: href,
    onClick: onClick,
    rel: target === '_blank' ? 'nofollow noopener' : undefined,
    tabIndex: 0,
    target: target
  }, extraAttributes, {
    "data-t-id": "src-Link"
  }), icon && /*#__PURE__*/React.createElement("div", {
    className: cn('link__icon')
  }, icon), children && /*#__PURE__*/React.createElement("span", _extends({
    className: cn('link__text', _defineProperty({
      'link__text--with-icon': Boolean(icon),
      'link__text--with-right-icon': Boolean(rightIcon)
    }, "link__text--".concat(buttonVariant), Boolean(buttonVariant)))
  }, spreadDangerousChildren(children))), rightIcon && /*#__PURE__*/React.createElement("div", {
    className: cn('link__icon')
  }, rightIcon));
});
Link.displayName = Link.name;